module.exports = __webpack_public_path__ + "img/ico-grade-blue.de01e77b.svg";